import { render, staticRenderFns } from "./invoice.vue?vue&type=template&id=536bdaf9"
import script from "./invoice.vue?vue&type=script&lang=ts"
export * from "./invoice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports